import { createFileRoute } from "@tanstack/react-router";

import { BASE_URL, OG_VERSION } from "@/common/links";
import { TermsContent } from "@/landing/legal/TermsContent";
import { PAGE_META } from "@/landing/lib/page-meta";

export const Route = createFileRoute("/_steward/terms")({
  component: TermsContent,
  head: () => ({
    meta: [
      { title: PAGE_META["/terms"].title },
      { name: "description", content: PAGE_META["/terms"].description },
      { property: "og:title", content: PAGE_META["/terms"].title },
      { property: "og:description", content: PAGE_META["/terms"].description },
      {
        property: "og:image",
        content: `${BASE_URL}/og/terms.png?v=${OG_VERSION}`,
      },
      { name: "twitter:title", content: PAGE_META["/terms"].title },
      { name: "twitter:description", content: PAGE_META["/terms"].description },
      {
        name: "twitter:image",
        content: `${BASE_URL}/og/terms.png?v=${OG_VERSION}`,
      },
    ],
    links: [{ rel: "canonical", href: `${BASE_URL}/terms` }],
  }),
});
